import DataStore from './DataStore'

export default DataStore
